module.exports = __webpack_public_path__ + "img/OMNI.d362e0d3.svg";